import React from 'react'
import "./industry.css";
export default function Signupindustrynav() {
 
  return (
    <>
   <header id="header" className="signupnav d-flex align-items-center">
        <div className="container d-flex align-items-center justify-content-between">
          <h1 className="logo">
            <a href='/'>PICT Campus Placement System<span></span></a>  
          </h1>
        </div>
      </header>
     
  </>
  )
}
